angular.module('app.filters').filter('merge', ($timeout) => (...args) => {
    const result = {};

    angular.forEach(args, (obj) => {
        angular.extend(result, obj);
    });

    return result;
});
